{
  "name": "@retracedgmbh/frontend",
  "version": "2.1219.2",
  "private": true,
  "license": "UNLICENSED",
  "type": "module",
  "scripts": {
    "build": "bash ../scripts/render-env-run.sh --command=\"NODE_OPTIONS=--max-old-space-size=4096 pnpm --filter @retracedgmbh/ui-components-lib build && vite build\"",
    "build-ci": "pnpm run build-ci:ui-lib && pnpm run build-ci:frontend",
    "build-ci:ui-lib": "cross-env NODE_OPTIONS=--max-old-space-size=4096 pnpm --filter @retracedgmbh/ui-components-lib build",
    "build-ci:frontend": "cross-env NODE_OPTIONS=--max-old-space-size=8192 vite build",
    "dev": "bash ../scripts/render-env-run.sh --command=\"vite --host --force\"",
    "dev:staging": "bash ../scripts/render-env-run.sh --env=development-frontend-target-staging --command=\"vite --host --force\"",
    "dev-edo": "vite --host --force",
    "dev-builder": "bash ../scripts/render-env-run.sh --env=development-frontend-target-staging --command=\"vite --host --force\"",
    "serve": "vite preview",
    "serve2": "bash ../scripts/render-env-run.sh --command=\"vite preview\"",
    "start": "DEBUG=vite:deps vite --force",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "lint": "biome check .",
    "lint:fix": "biome check --write .",
    "lint:imports": "../scripts/check-react-query-imports.sh $(find src -name '*.ts' -o -name '*.tsx' -o -name '*.js' -o -name '*.jsx')",
    "lint:imports:staged": "../scripts/check-react-query-imports.sh"
  },
  "browserslist": [
    "> 2%",
    "last 2 versions",
    "not IE 11",
    "not OperaMini all",
    "not dead"
  ],
  "dependencies": {
    "@datadog/browser-core": "7.16.1",
    "@datadog/browser-rum": "7.16.1",
    "@datadog/browser-rum-core": "7.16.1",
    "@getnuvo/importer-react": "3.0.0",
    "@hookform/error-message": "2.0.1",
    "@hookform/resolvers": "6.0.0",
    "@intercom/messenger-js-sdk": "0.0.19",
    "@popperjs/core": "catalog:",
    "@react-spring/web": "10.1.2",
    "@retracedgmbh/data-points-lib": "workspace:*",
    "@retracedgmbh/modules": "workspace:*",
    "@retracedgmbh/ui-components-lib": "workspace:*",
    "@tailwindcss/vite": "catalog:",
    "@tanstack/react-query": "5.104.5",
    "@tanstack/react-query-devtools": "5",
    "ahooks": "3.10.0",
    "classnames": "catalog:",
    "compute-scroll-into-view": "1.0.17",
    "cross-env": "10.1.0",
    "dagre": "0.8.5",
    "date-fns": "catalog:",
    "entities": "8.1.0",
    "exceljs": "4.4.0",
    "fetch-event-stream": "0.1.5",
    "file-selector": "catalog:",
    "i18next": "catalog:",
    "i18next-browser-languagedetector": "8.2.2",
    "i18next-http-backend": "4.0.5",
    "install": "0.13.0",
    "jwt-decode": "4.0.0",
    "lodash-es": "4.18.1",
    "maplibre-gl": "catalog:",
    "rc-util": "5.44.4",
    "react": "catalog:",
    "react-beautiful-dnd": "13.1.1",
    "react-circular-progressbar": "catalog:",
    "react-dom": "catalog:",
    "react-dropzone": "catalog:",
    "react-hook-form": "catalog:",
    "react-i18next": "catalog:",
    "react-json-view": "1.21.3",
    "react-json-view-compare": "2.0.2",
    "react-loading-skeleton": "3.5.0",
    "react-markdown": "catalog:",
    "react-router-dom": "7.18.4",
    "react-virtualized": "10.0.0",
    "react-virtualized-auto-sizer": "1.0.26",
    "reactflow": "11.11.4",
    "recharts": "3.10.1",
    "regenerator-runtime": "0.14.1",
    "rehype-raw": "7.0.0",
    "scroll-into-view-if-needed": "2.2.28",
    "spark-md5": "3.0.2",
    "tailwindcss-animate": "catalog:",
    "ulid": "catalog:",
    "uuid": "catalog:",
    "yup": "1.6.1",
    "zod": "catalog:",
    "zustand": "4.5.5"
  },
  "devDependencies": {
    "@biomejs/biome": "catalog:",
    "@datadog/datadog-ci": "5.25.0",
    "@fullhuman/postcss-purgecss": "catalog:",
    "@tailwindcss/typography": "0.5.20",
    "@testing-library/jest-dom": "7.0.1",
    "@testing-library/react": "16.3.3",
    "@testing-library/user-event": "catalog:",
    "@types/node": "catalog:",
    "@types/spark-md5": "*",
    "@vitejs/plugin-react": "6.1.2",
    "@vitest/coverage-v8": "catalog:",
    "babel-loader": "10.1.1",
    "babel-plugin-transform-react-remove-prop-types": "0.4.24",
    "esbuild": "catalog:",
    "jsdom": "30.1.3",
    "msw": "2.14.2",
    "nanoid": "catalog:",
    "postcss": "catalog:",
    "sass": "catalog:",
    "tailwindcss": "catalog:",
    "tsx": "catalog:",
    "typescript": "catalog:",
    "vite": "catalog:",
    "vitest": "catalog:"
  },
  "engines": {
    "node": ">=24.22.1 <25.0.0"
  },
  "overrides": {
    "glob-to-regexp@<0.4.1": "0.4.1",
    "source-map-support@<0.5.21": "0.5.21"
  },
  "staticFiles": {
    "staticPath": "public"
  }
}
